import styles from "./list.module.css";

const SkeletonRow = () => (
    <div className={styles.SkeletonRow}>
        <div className={`${styles.SkeletonBase} ${styles.SkeletonCheckbox}`} />
        <div className={styles.SkeletonCol}>
            <div className={`${styles.SkeletonBase} ${styles.SkeletonLineShort}`} />
        </div>
        <div className={styles.SkeletonCol}>
            <div className={`${styles.SkeletonBase} ${styles.SkeletonLine}`} />
        </div>
        <div className={styles.SkeletonCol}>
            <div className={`${styles.SkeletonBase} ${styles.SkeletonLine}`} />
        </div>
        <div className={styles.SkeletonCol}>
            <div className={`${styles.SkeletonBase} ${styles.SkeletonLineShort}`} />
        </div>
        <div className={`${styles.SkeletonBase} ${styles.SkeletonButton}`} />
    </div>
);

/**
 * Skeleton content loader for the Picked Items table.
 * Mirrors the real row layout (checkbox, booking id, customer, address,
 * date, action button) so the page doesn't visually "jump" once data loads.
 * Fully responsive — collapses into stacked cards on small screens via
 * the shared list.module.css rules.
 */
const PickedItemsLoader = ({ rows = 6 }) => {
    return (
        <div className={styles.SkeletonLoaderWrap} role="status" aria-label="Loading picked items">
            <div className={styles.SkeletonHeaderRow}>
                <div className={`${styles.SkeletonBase}`} style={{ width: 18, height: 18, borderRadius: 4 }} />
                <div className={`${styles.SkeletonBase}`} style={{ width: 90 }} />
                <div className={`${styles.SkeletonBase}`} style={{ width: 130 }} />
                <div className={`${styles.SkeletonBase}`} style={{ width: 160 }} />
                <div className={`${styles.SkeletonBase}`} style={{ width: 90 }} />
                <div className={`${styles.SkeletonBase}`} style={{ width: 92, marginLeft: "auto" }} />
            </div>

            {Array.from({ length: rows }).map((_, i) => (
                <SkeletonRow key={i} />
            ))}
        </div>
    );
};

export default PickedItemsLoader;